/** @jsxImportSource @emotion/react */

import { FC } from 'react'
import { FieldArray } from 'react-final-form-arrays'
import { FormState } from '../consts'
import * as formClasses from '../styles'
import { RxWritingAnswersFieldArray } from './components/RxWritingAnswersFieldArray'

const validateAnswers = (value: FormState['answer']) => {
  if ((value?.length ?? 0) < 1) {
    return `Should be at least 1 answer`
  }

  return undefined
}

type Props = {
  onAnswerChange: () => void
}

export const RxWritingAnswers: FC<Props> = ({ onAnswerChange }) => (
  <>
    <div css={formClasses.title}>Answers</div>
    <FieldArray name="rxWritingAnswer" validate={(value) => validateAnswers(value)}>
      {({ fields, meta }) => <RxWritingAnswersFieldArray fields={fields} meta={meta} onAnswerChange={onAnswerChange} />}
    </FieldArray>
  </>
)
